import axios from "axios";
import { getSessionId } from "../../../utils/tokenHandlers";
import UidEmailRoleMatch from "../../constants/uidEmailRoleMatch";

export const getBizNameGSTINMaster = (gstinValue: string) => {
  const UidEmailRole = UidEmailRoleMatch();

  const sessionId = getSessionId();
  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}api/read/many/tradexwbench.temp_gst_details`,
      {
        params: {
          ...UidEmailRole,
          filter: `[['gstin', '=', '${gstinValue}']]`,
          query: "{gstin,tradeName,lgnm,bnm,st,bno,city,loc,stcd,pncd,ctb}",
        },
      },
      {
        headers: {
          Authorization: `Bearer ${sessionId}`,
        },
      }
    )
    .then((response) => {
      return response;
    })
    .catch((err) => err);
};
